import ClientLogResource from 'flow/api/clientlog';
import Enum from 'enum';

import { networkErrorDispatcher } from 'flow/actions/app-actions';
import {
    getLog,
    clearLog,
    hasLogs,
    addGeneralLogEntry,
} from 'flow/utils/browser-utils';
import { isEmptyNullOrUndefined } from 'flow/utils';
import { isTeamsFullClient } from '../utils/app-utils';
import EmbeddedType from 'flow/types/embedded-type';

/**
 * For reference, see ClientLogDTO in Partner
 */
export const REASON = new Enum(['USER_INITIATED', 'TIMER', 'DEBUG_CRASH']);

const CLIENTS = new Enum(['DESKTOP', 'OPERATOR', 'FLOWAPP']);

const SEND_LOGS_RATE_MS = 1000 * 60 * 10; //1000 * 60 * 10 = 600 000 milliseconds = 10 minutes

let sendLogsTimer = null;

export const sendExistingUserLogsOnInterval = async (dispatch) => {
    cancelSendingLogsOnInterval();

    const logsExist = await hasLogs();
    if (logsExist) {
        dispatch(sendAllLogs(REASON.TIMER));
    }

    sendLogsTimer = setInterval(async () => {
        const logsExist = await hasLogs();
        if (logsExist) {
            dispatch(sendAllLogs(REASON.TIMER));
        }
    }, SEND_LOGS_RATE_MS);
};

export const cancelSendingLogsOnInterval = () => {
    clearInterval(sendLogsTimer);
    sendLogsTimer = null;
};

export const sendAllLogs = (reason) => async (dispatch) => {
    try {
        let logs;
        const shouldClearLog = reason !== REASON.USER_INITIATED;
        try {
            logs = await getLog(shouldClearLog);
        } catch (error) {
            clearLog();
            throw error;
        }

        if (logs) {
            await dispatch(sendLog(logs, reason));
        }
    } catch (error) {
        addGeneralLogEntry(`ERROR when sending all logs: ${error}`);
    }
};

const sendLog =
    (log, reason = '') =>
    (dispatch, getState) => {
        if (isEmptyNullOrUndefined(log)) {
            return Promise.resolve();
        }

        const logReason = reason.toString();
        const embedded = getState().app.get('embedded');
        // TEAMSFVMANUAL reports as TEAMSFV: ClientLogType (ClientLogDTO in
        // telavox-api-internal) has no such constant, and the value is sent as a
        // path segment whose conversion throws on anything unknown.
        const clientLogType = isTeamsFullClient(embedded)
            ? EmbeddedType.TEAMSFV.toString()
            : CLIENTS.FLOWAPP.toString();
        const clientLogDTO = {
            log,
            logReason,
            clientLogType,
        };

        return new Promise((resolve, reject) => {
            ClientLogResource.createLog(
                {
                    onResult() {
                        resolve();
                    },
                    onError: (error) => {
                        networkErrorDispatcher(dispatch)(error);
                        reject(error);
                    },
                    onClientError: (error) => {
                        reject(error);
                    },
                },
                clientLogType,
                clientLogDTO,
            );
        });
    };
